import React from 'react'
import { Box } from '@mui/material'

export default function PrivacyTabContent() {
  return <Box>Privacy & Security Placeholder</Box>
} 